import { type NotificationType } from "../Messages/NotificationType";
import type { OccDateString } from "~/app/api/occ/OccDateString";
import type { NotificationData } from "~/features/notifications/Messages";
import type { DeprecatedOccPaginationDTO } from "~/app/api/occ/DeprecatedOccPaginationDTO";

export interface BaseNotificationDTO {
  uid: string;
  notificationDate: OccDateString;
  read: boolean;
  subType: string;
  subTypeCode: NotificationType;
  type: string;
  typeCode: string;
}

export interface QuoteNotificationDTO extends BaseNotificationDTO {
  subTypeCode: NotificationType.StatusChangeQuote | NotificationType.ExpireQuote;
  salesOrg: string;
  account: string;
  displayAccount: string;
  quoteNumber: string;
  expirationDate: OccDateString;
  endCustomerNumber?: string;
}

export interface GeneralNotificationDTO extends BaseNotificationDTO {
  subTypeCode: NotificationType.GeneralNotification | NotificationType.ReleaseNotes;
  title: string;
  content: string;
}

export type NotificationDTO = QuoteNotificationDTO | GeneralNotificationDTO;

export interface NotificationListResponseDTO {
  notifications?: NotificationDTO[];
}

export interface NotificationSearchResponseDTO {
  results?: NotificationDTO[];
  pagination?: DeprecatedOccPaginationDTO;
}

export function transformNotificationDTO(dto: NotificationDTO): NotificationData {
  const notificationDate = Date.parse(dto.notificationDate);

  if ("expirationDate" in dto) {
    return {
      ...dto,
      notificationDate,
      expirationDate: Date.parse(dto.expirationDate),
    } as NotificationData;
  }

  return { ...dto, notificationDate } as NotificationData;
}
